import classNames from "classnames";

export default function ex(css, props = {}) {
  if(typeof props === 'string') {
    debugger;
    throw new Error('ex argument error');
  }

  let nextProps = { ...props };
  nextProps['className'] = [nextProps['className'], classNames(...[css].flat())].filter(Boolean).join(' ');
  return nextProps;
};